<section data-id="processing-error" class="hidden">
  <div class="card card-center card-style" style="background-color: white!important;">
    <div class="content">
      <h1 class="text-uppercase text-center" data-id="headline"></h1>
      <div class="d-flex justify-content-center font-weight-bolder" data-id="content"></div>
    </div>
  </div>
</section>
<section data-id="email-validation-success" class="hidden">
  <div class="card card-center card-style" style="background-color: white!important;">
    <div class="content">
      <h1 class="text-uppercase text-center">
        Registration erfolgreich
      </h1>
      <div class="font-weight-bolder text-center">
        <p>Die Registration wurde erfolgreich abgeschlossen.</p>
        <p>Dein Account ist nun angelegt und du kannst dich einloggen.</p>
        <p>
          <a href="/login"
             class="btn btn-xl mb-2 mt-3 rounded-xl text-uppercase font-700 btn-shadow-l bg-primary text-white">
            Zum Login
          </a>
        </p>
      </div>
    </div>
  </div>
</section>
<section data-id="set-new-password-form"
         class="hidden">
  <div class="card card-center" style="background-color: transparent!important;">
    <div class="content">
      <h1 class="mb-4 text-white">Neues Passwort</h1>
      <p class="mt-3 text-white font-weight-bolder">
        Gebe Dein neues Passwort ein.
      </p>
      <form data-id="new-password-form">
        <div class="input-style input-style-always-active no-borders has-icon validate-field mb-5 mt-5">
          <i class="fa fa-lock"></i>
          <input type="password"
                 name="password"
                 class="form-control"
                 minlength="6"
                 maxlength="32"
                 id="input-new-password"
                 required>
          <label for="input-new-password" class="color-primary text-uppercase font-700 font-10">Neues Password</label>
          <i class="fa fa-times invalid color-red-dark"></i>
          <div class="input-error color-red-dark">
            Das Passwort muss mindestens aus 6 Zeichen bestehen.
          </div>
        </div>
        <p style="text-align: center">
          <button data-id="btnSaveNewPassword"
                  type="button"
                  style="margin: auto"
                  class="btn btn-l mb-3 mt-1 rounded-xs text-uppercase font-700 btn-shadow-l bg-white text-primary">Neues Password Speichern</button>
        </p>
      </form>
    </div>
  </div>
</section>
<section data-id="set-new-password-success" class="hidden">
  <div class="card card-center card-style" style="background-color: white!important;">
    <div class="content">
      <h1 class="text-uppercase text-center">
        Passwort erfolgreich geändert
      </h1>
      <div class="font-weight-bolder text-center">
        <p>Das Passwort wurde erfolgreich geändert.</p>
        <p>Bitte verwende ab nun immer das neue Passwort.</p>
        <p>
          <a href="/login"
             class="btn btn-xl mb-2 mt-3 rounded-xl text-uppercase font-700 btn-shadow-l bg-primary text-white">
            Zum Login
          </a>
        </p>
      </div>
    </div>
  </div>
</section>
